module.exports = __webpack_public_path__ + "static/img/Splash.8c2cf5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Splash.png
// module id = G1gl
// module chunks = 1